import FeaturedService from '@/components/FeaturedService';
import { fadeInUp } from '@/constants/motions';
// import { services } from '@/content';
import { motion } from 'framer-motion';

export default function FeaturedServicesBlock({ services }) {
  const safeServices = services || [];
  return (
    <div className="mt-8 px-4 md:-mt-16">
      <div className="container-screen">
        <motion.div
          className="grid grid-cols-2 gap-4 lg:grid-cols-4"
          initial="hidden"
          transition={{
            ...fadeInUp.transition,
            when: 'beforeChildren',
            staggerChildren: 0.4,
          }}
          variants={fadeInUp}
          viewport={fadeInUp.viewport}
          whileInView="visible"
        >
          {safeServices.map((service, i) => (
            <FeaturedService {...service} key={i} />
          ))}
        </motion.div>
      </div>
    </div>
  );
}
